import { render, staticRenderFns } from "./SituacaoOrcamento.vue?vue&type=template&id=63a649b6&scoped=true"
import script from "./SituacaoOrcamento.vue?vue&type=script&lang=js"
export * from "./SituacaoOrcamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a649b6",
  null
  
)

export default component.exports